<template>
    <div class="content">
        <div class="coupon">

            <!-- 选择银行卡 -->
            <div class="bank-selector">
                <div class="label">提现账号</div>
                <van-cell center is-link @click="routeBankList" v-if="bank.bankType === 2">
                    <!-- 使用 title 插槽来自定义标题 -->
                    <template #title>
                        <div>微信提现{{ bank.accountHolder ? '(' + bank.accountHolder + ')' : '' }}</div>
                    </template>
                </van-cell>
                <van-cell center is-link @click="routeBankList" v-else>
                    <!-- 使用 title 插槽来自定义标题 -->
                    <template #title>
                        <div>
                            姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：{{ bank.accountHolder }}
                            <span style="font-size: 12px; color:red; float:right;">
                                {{ ['24小时内到账', '即时到账'][bank.bankType] }}
                            </span>
                        </div>
                        <div v-show="bank.bankType === 0">银行名称：{{ bank.bankName }}</div>
                        <div>账&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：{{ bank.bankAccount }}</div>
                    </template>
                </van-cell>
            </div>

            <!-- 卡券信息 -->
            <div class="label">卡券信息</div>
            <div class="coupon-box">
                <div class="coupon-info">
                    <!-- <div class="coupon-info-left">
                        <van-image width="5rem" height="5rem" fit="contain" :src="logoImage" />
                    </div> -->
                    <div class="coupon-info-right">
                        <div class="coupon-name">{{ coupon.couponsProductName }}</div>
                        <div class="coupon-num">No.{{ coupon.couponsNum }}</div>
                        <div class="coupon-default-font">有效期：{{ coupon.couponsEndDate }}</div>
                        <div class="coupon-default-font">权益：{{ Number(coupon.couponsBalance).toFixed(2) }} </div>
                        <div class="coupon-default-font">折扣：{{ coupon.couponsWechatRedpacketRebate * 100 }} 折</div>
                        
                        <div v-if="needShowServiceCharge" class="coupon-default-font">提现手续费：1 元</div>
                        <div class="coupon-default-font">
                            提现金额：{{ getWithdrawBalance() }} 元
                        </div>
                        <div class="coupon-default-font">
                            消耗权益：{{ getWithdrawAmount() }} 
                        </div>
                    </div>
                </div>
            </div>

            <div class="max-limit-tip">
                <div>- 快捷提现 -> {{ type === 'bankWithdraw' ? '银行卡' : '支付宝' }} 每日限额{{withdrawQuota}}元</div>
                <div>- 今日剩余额度{{remainingWithdrawQuota}}元</div>
            </div>

            <!-- button -->
            <div class="buttons" v-show="btnShow">
                <van-button type="primary" :loading="btnLoading" loading-text="处理中 ..." block @click="handleWithdraw"> 提
                    现
                </van-button>
            </div>
        </div>
    </div>
</template>
<script>
import { withdrawApi, getQuickWithdrawQuotaApi } from "api/withdraw"
import { Dialog } from "vant";
import { getBankList } from "api/onLine"
export default {
    data() {
        return {
            btnShow: true,
            btnLoading: false,
            coupon: this.$store.state.coupon,
            // logoImage: require("assets/gift01.png"),
            bank: {},
            wechatPayList: [],
            // 每日可提现额度
            withdrawQuota: 0,
            // 今日剩余可提现额度
            remainingWithdrawQuota: 0,
            type: ''
        }
    },
    async mounted() {
        this.type = this.$route.query.type || ''
        if (!this.coupon || !this.coupon.couponsId) {
            this.$push({ name: 'Coupon' })
        } 
        else {
            const params = this.$route.params
            if (params.bankId) {
                this.bank = params
            } else {
                this.fetchDefaultAccount()
            }

        }
        await this.fetchRemainingQuota()
    },
    computed: {
        needShowServiceCharge() {
            if(!this.coupon.lowAmountLimit || !this.coupon.lowAmountAdditiveFee) return false
            return this.getWithdrawBalance() < this.coupon.lowAmountLimit
        },
        // 计算属性，判断是否显示按钮
        actualWithdrawAmount() {
            if (this.needShowServiceCharge) {
                const fee = Number(this.coupon.lowAmountAdditiveFee)
                const amount = (this.coupon.couponsBalance * this.coupon.couponsWechatRedpacketRebate - fee).toFixed(2) 
                return amount > 0 ? amount : 0
            }
            return (this.coupon.couponsBalance * this.coupon.couponsWechatRedpacketRebate).toFixed(2) 
        },
    },
    methods: {
        getWithdrawAmount() {
            //获取提现消费面额
            let balance = this.actualWithdrawAmount > this.remainingWithdrawQuota ? this.remainingWithdrawQuota : this.actualWithdrawAmount
            return Number((balance / this.coupon.couponsWechatRedpacketRebate).toFixed(2))
        },
        getWithdrawBalance() {
            //获取提现到账金额
            let balance = this.actualWithdrawAmount > this.remainingWithdrawQuota ? this.remainingWithdrawQuota : this.actualWithdrawAmount
            return Number(balance)
        },
        async fetchRemainingQuota() {
            let params = {
                bankType: this.type == 'bankWithdraw' ? 0 : 1,
            }
            const { status, data } = await getQuickWithdrawQuotaApi(params)
            if (status === 200) {
                this.withdrawQuota = data.withdrawQuota ?? 0
                this.remainingWithdrawQuota = data.remainingWithdrawQuota ?? 0
            }
        },
        routeBankList() {
            // this.$push({ name: 'BankList', params: this.coupon })
            this.$push({ name: 'AccountList', params: this.coupon, query: {type: this.type} })
        },
        async fetchDefaultAccount() {
            getBankList(this.coupon.couponsNum).then(({data, message, status}) => {
                if (status == 200) {
                    let bankList = data.filter((item) => item.bankType != 2)
                    let defaultBank = null;
                    if(this.type == 'bankWithdraw'){
                        bankList = data.filter((item) => item.bankType === 0)
                        defaultBank = bankList.find((item) => item.bankIsDefault === 1)
                    }else if(this.type == 'alipayWithdraw'){
                        bankList = data.filter((item) => item.bankType === 1)
                        defaultBank = bankList.find((item) => item.bankIsDefault === 1)
                    }
                    this.bank = defaultBank ?? bankList[0]
                    if (this.bank == undefined) {
                        this.$toast('请先添加提现账号',4000)
                    }
                } else {
                    this.$error(message)
                }
            })
        },
        async handleWithdraw() {
            if (this.bank.bankType === 2 && !this.bank.accountHolder) {
                this.$toast('请先进入提现账号列表并完善微信提现姓名信息')
                return
            }
            if (this.remainingWithdrawQuota <= 0) {
                this.$toast(`今日剩余可提现额度不足`)
                return
            }
            this.btnLoading = true
            const data = { 
                couponId: this.coupon.couponsId,
                bankId: this.bank.bankId,
                couponAmount: this.getWithdrawAmount(),
                actualAmount: this.getWithdrawBalance()
            }
            const { status, message } = await withdrawApi(data)
            this.btnLoading = false
            if (status === 200) {
                this.btnShow = false
                this.$store.commit('setCoupon', null)
                this.handleRoute()
            } else {
                this.$toast(message)
            }
        },
        handleRoute() {
            Dialog.alert({
                message: '提现申请成功，请留意余额变动'
            }).then(() => {
                this.$push({ path: '/withdrawList?type=-1' })
            })
        }
    }
}
</script>
<style scoped>
.content {
    height: 100%;
    position: relative;
    color: rgba(69, 90, 100, .6);
    background-color: #e4e6eb;
}

.coupon {
    padding: 2px 15px;
    position: relative;
}

.bank-selector {
    border-radius: 5px;
}

.label {
    padding: 5px 0;
}

.coupon-box {
    position: relative;
}

.coupon-info {
    display: flex;
    position: relative;
    background-color: #ffffff;
    border-radius: 2px;
}

.coupon-info-left {
    flex: 3;
    padding: 10px 5px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.coupon-info-right {
    flex: 7;
    padding: 10px 15px;
}

.coupon-name {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.884)
}

.coupon-num {
    margin: 2px 0;
}

.coupon-default-font {
    font-size: 16px;
    color: rgb(121, 121, 121);
}

.buttons {
    margin: 15px 0;

}

.van-button__text {
    letter-spacing: 10px;
    text-indent: 10px;
    text-align: center;
}
.max-limit-tip {
    background: #FFF7E6;
    border: 1px solid #FFE082;
    border-radius: 8px;
    padding: 10px 15px;
    margin: 12px 0 12px 0;
    font-size: 13px;
    color: #E65C00;
}
</style>
